export default (state = [], action) => {
  switch (action.type) {
    case "INSCRICAO_REALIZADA":
      return { ...state,subscribed:action.resposta };
    default:
      return state;
  }
};
